import { type FunctionComponent, type PropsWithChildren, type ReactElement } from 'react';
import { type QueryStatus } from '@adv-frontend/modules-query';
import { ErrorBlankSad, ErrorBlankSpinner, ErrorBlankTears } from '../ErrorBlank';

export interface StatusWrapperProps {
    queryStatus?: QueryStatus;
    isFetching?: boolean;
    renderFetching?: () => ReactElement;
    isError?: boolean;
    renderError?: () => ReactElement;
    isEmpty?: boolean;
    renderEmpty?: () => ReactElement;
}

const defaultRenderFetching = () => <ErrorBlankSpinner title="Данные грузятся" />;
const defaultRenderError = () => <ErrorBlankTears title="Что-то пошло не так" />;
const defaultRenderEmpty = () => <ErrorBlankSad title="А в результате пусто" />;

/*
 * Компонент-обертка, который помогает делать интерфейс дружелюбнее, позволяя отображать разные компонента в зависимости от состояния загрузки данных
 */
export const StatusWrapper: FunctionComponent<PropsWithChildren<StatusWrapperProps>> = ({
    queryStatus,
    children,
    isFetching,
    renderFetching = defaultRenderFetching,
    isError,
    renderError = defaultRenderError,
    isEmpty,
    renderEmpty = defaultRenderEmpty,
}) => {
    if (isFetching || queryStatus === 'pending' || queryStatus === 'uninitialized') {
        return renderFetching();
    }

    if (isError || queryStatus === 'rejected') {
        return renderError();
    }

    if (isEmpty) {
        return renderEmpty();
    }

    return <>{children}</>;
};
